/** マス数・付与ポイントはリポジトリ直下 `shared/stampVisitMath.mjs` が単一ソース */
export { STAMP_CARD_SLOT_COUNT, POINTS_PER_VISIT } from "../../shared/stampVisitMath.mjs";

/** 20スタンプ達成時の会計割引額（円） */
export const STAMP_REWARD_DISCOUNT_YEN = 1000;
